// Portal: Renewal Calendar. Active sites with subscription renewal
// dates inside the next 90 days (or already past). Dates only -- no
// pricing on the portal; invoicing continues through QuickBooks.

import { useEffect, useState } from 'react';
import axios from 'axios';

const MONTHS_SHORT = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
function fmtDate(iso) {
  if (!iso) return '—';
  const [y, m, d] = String(iso).slice(0, 10).split('-');
  if (!y || !m || !d) return '—';
  return `${MONTHS_SHORT[Number(m) - 1] || m} ${d}, ${y}`;
}

export default function PortalRenewals() {
  const [rows, setRows] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    axios.get('/api/portal/renewals')
      .then((res) => { if (!cancelled) setRows(res.data); })
      .catch(() => { if (!cancelled) setError('Failed to load renewals. Please try again.'); });
    return () => { cancelled = true; };
  }, []);

  return (
    <section className="page">
      <div className="page-header">
        <h2>Upcoming Renewals</h2>
        <span className="portal-count">Next 90 days</span>
      </div>

      {error && <p className="portal-error">{error}</p>}
      {!rows && !error && <p className="placeholder-note">Loading…</p>}

      {rows && rows.length === 0 && (
        <p className="placeholder-note">No renewals due in the next 90 days.</p>
      )}

      {rows && rows.length > 0 && (
        <>
          <div className="table-wrap" style={{ maxWidth: 720 }}>
            <table className="data-table" style={{ width: '100%' }}>
              <thead>
                <tr>
                  <th>Site</th>
                  <th>Modules Renewing</th>
                  <th>Renewal Date</th>
                  <th>Due</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.id}>
                    <td>
                      <div>{r.site_name}</div>
                      <div className="mono" style={{ color: 'var(--color-text-faint)', fontSize: 'var(--text-small)' }}>
                        {r.site_number}
                      </div>
                    </td>
                    <td>{(r.modules_due || []).join(', ') || '—'}</td>
                    <td className="mono">{fmtDate(r.renewal_date)}</td>
                    <td>
                      {r.overdue ? (
                        <span className="portal-pill portal-pill-bad">Due now</span>
                      ) : r.days_until <= 30 ? (
                        <span className="portal-pill portal-pill-warn">In {r.days_until} day{r.days_until === 1 ? '' : 's'}</span>
                      ) : (
                        <span className="portal-pill portal-pill-good">In {r.days_until} days</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <p className="portal-footnote">
            Renewal invoices are issued separately. To discuss a renewal,
            use the <a href="/portal/support">Support</a> tab or reply to
            your renewal reminder email.
          </p>
        </>
      )}
    </section>
  );
}
